/* 33 1/3 — minimal theme behaviour. No dependencies. */
(function () {
  "use strict";

  var root = document.documentElement;

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
    var items = (scope || document).querySelectorAll(".reveal:not(.is-visible)");
    if (!("IntersectionObserver" in window)) {
      items.forEach(function (el) {
        el.classList.add("is-visible");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0.08 }
    );
    items.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var header = document.querySelector("[data-header]");
    if (!header) return;

    function setHeight() {
      var nav = header.querySelector("nav");
      if (nav) root.style.setProperty("--header-h", nav.offsetHeight + "px");
    }
    setHeight();
    window.addEventListener("resize", setHeight, { passive: true });

    if (header.hasAttribute("data-overlay")) {
      var onScroll = function () {
        header.classList.toggle("is-solid", window.scrollY > 80);
      };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }

    var burger = header.querySelector("[data-burger]");
    var menu = header.querySelector("[data-mobile-menu]");
    if (burger && menu) {
      burger.addEventListener("click", function () {
        var open = header.classList.toggle("is-open");
        burger.setAttribute("aria-expanded", open ? "true" : "false");
        menu.hidden = !open;
        document.body.classList.toggle("no-scroll", open);
      });
      menu.addEventListener("click", function (e) {
        if (e.target.closest("a")) {
          header.classList.remove("is-open");
          burger.setAttribute("aria-expanded", "false");
          menu.hidden = true;
          document.body.classList.remove("no-scroll");
        }
      });
    }
  }

  /* ---------- Film ---------- */
  function initFilm() {
    document.querySelectorAll("[data-film]").forEach(function (frame) {
      var video = frame.querySelector("video");
      var btn = frame.querySelector("[data-film-play]");
      if (!video || !btn) return;
      btn.addEventListener("click", function () {
        video.muted = false;
        video.controls = true;
        frame.classList.add("is-playing");
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });
      video.addEventListener("pause", function () {
        if (video.currentTime === 0) frame.classList.remove("is-playing");
      });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq() {
    document.querySelectorAll("[data-faq-question]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest("[data-faq-item]");
        var answer = item.querySelector("[data-faq-answer]");
        var opening = !item.classList.contains("is-open");

        document.querySelectorAll("[data-faq-item].is-open").forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove("is-open");
            var q = openItem.querySelector("[data-faq-question]");
            var a = openItem.querySelector("[data-faq-answer]");
            if (q) q.setAttribute("aria-expanded", "false");
            if (a) a.hidden = true;
          }
        });

        item.classList.toggle("is-open", opening);
        btn.setAttribute("aria-expanded", opening ? "true" : "false");
        if (answer) answer.hidden = !opening;
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-qty]");
      if (!btn) return;
      var input = btn.parentElement.querySelector("input");
      if (!input) return;
      var step = btn.getAttribute("data-qty") === "up" ? 1 : -1;
      var min = parseInt(input.getAttribute("min") || "1", 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  /* ---------- Variant picking ---------- */
  function initVariants() {
    document.querySelectorAll("[data-product-form]").forEach(function (wrapper) {
      var dataEl = wrapper.querySelector("[data-variants]");
      if (!dataEl) return;
      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }
      var idInput = wrapper.querySelector("[data-variant-id]");
      var priceEl = wrapper.querySelector("[data-price]");
      var submit = wrapper.querySelector("[data-add]");

      function selected() {
        return Array.prototype.map.call(
          wrapper.querySelectorAll("[data-option-index]"),
          function (group) {
            var checked = group.querySelector("input:checked");
            return checked ? checked.value : (group.value || null);
          }
        );
      }

      function update() {
        var opts = selected();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) {
            return opts[i] == null || o === opts[i];
          });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available
            ? submit.getAttribute("data-label-default")
            : submit.getAttribute("data-label-soldout");
        }
        if (history.replaceState && match.id) {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", match.id);
          history.replaceState({}, "", url.toString());
        }
        var media = wrapper
          .closest("[data-product]")
          ?.querySelector('[data-media-id="' + match.featured_media_id + '"]');
        if (media) media.click();
      }

      wrapper.addEventListener("change", function (e) {
        if (e.target.closest("[data-option-index]")) update();
      });
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-gallery-main]");
      gallery.querySelectorAll("[data-media-id]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          if (!main) return;
          main.src = thumb.getAttribute("data-src");
          main.srcset = thumb.getAttribute("data-srcset") || "";
          main.alt = thumb.getAttribute("data-alt") || "";
          gallery.querySelectorAll("[data-media-id]").forEach(function (t) {
            t.setAttribute("aria-current", t === thumb ? "true" : "false");
          });
        });
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = null;

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("no-scroll");
    var close = drawer.querySelector("[data-cart-close]");
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("no-scroll");
  }

  function refreshCart() {
    if (!drawer) return Promise.resolve();
    var section = drawer.getAttribute("data-section-id");
    return fetch(window.Shopify.routes.root + "?sections=" + section)
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        var html = json[section];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-cart-contents]");
        var target = drawer.querySelector("[data-cart-contents]");
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        var count = doc.querySelector("[data-cart-count]");
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = count ? count.textContent : el.textContent;
        });
      });
  }

  function initCart() {
    drawer = document.querySelector("[data-cart-drawer]");

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-open]") && drawer) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest("[data-cart-close]") || e.target.closest("[data-cart-scrim]")) {
        closeDrawer();
        return;
      }
      var remove = e.target.closest("[data-cart-remove]");
      if (remove && drawer) {
        e.preventDefault();
        changeLine(remove.getAttribute("data-line"), 0);
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });

    document.addEventListener("change", function (e) {
      var input = e.target.closest("[data-cart-qty]");
      if (input && drawer) changeLine(input.getAttribute("data-line"), input.value);
    });

    /* AJAX add to cart */
    document.addEventListener("submit", function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form || !drawer) return;
      e.preventDefault();
      var btn = form.querySelector("[data-add]");
      if (btn) btn.setAttribute("aria-busy", "true");
      var body = new FormData(form);
      body.append("sections", drawer.getAttribute("data-section-id"));
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: body,
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          if (data.status) {
            var err = form.querySelector("[data-form-error]");
            if (err) err.textContent = data.description || data.message;
            return;
          }
          return refreshCart().then(openDrawer);
        })
        .finally(function () {
          if (btn) btn.removeAttribute("aria-busy");
        });
    });
  }

  function changeLine(line, quantity) {
    if (!line) return;
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        if (document.querySelector("[data-cart-page]")) {
          window.location.reload();
        } else {
          refreshCart();
        }
      });
  }

  function boot() {
    initReveal();
    initHeader();
    initFilm();
    initFaq();
    initQty();
    initVariants();
    initGallery();
    initCart();
  }

  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);

  /* Theme editor re-renders */
  document.addEventListener("shopify:section:load", function (e) {
    initReveal(e.target);
    initHeader();
    initFilm();
    initFaq();
    initVariants();
    initGallery();
    drawer = document.querySelector("[data-cart-drawer]");
  });
})();
